import * as React from 'react';
import { Icon } from './Icon';
import { observer } from 'mobx-react';

export interface ILockIconProps {
    className?: string;
    fill?: string;
    disabled?: boolean;
}
// eslint-disable-next-line @typescript-eslint/quotes
const image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' preserveAspectRatio='none' fill='%23000000' stroke-width='1px' %3E%3Cpath d='M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' /%3E%3C/svg%3E")`;

const LockIcon = observer((props: ILockIconProps) => {
    const className = `lock-icon ${props.className}`;

    return <Icon className={className} size={'large'} image={image} disabled={props.disabled} />;
});

export { LockIcon };
